import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller, useFormContext } from "react-hook-form";

import StyledSwitch from "@/components/forms/StyledSwitch";
import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface TimeRestrictionFieldProps {
  control: Control<CryptorFormData, {}>;
}

const TimeRestrictionField: FC<TimeRestrictionFieldProps> = ({ control }) => {
  const form = useFormContext();
  return (
    <>
      <StyledSwitch
        control={control}
        name="timeRestriction"
        label="Restrictions d'horaire"
      />
      {form.watch("timeRestriction") && (
        <Controller
          control={control}
          name="timeRestrictionUrl"
          render={({ field, fieldState }) => (
            <TextField
              InputLabelProps={{ shrink: true }}
              type="text"
              label="URL de la page de restrictions d'horaire"
              value={field.value}
              onChange={field.onChange}
              margin="normal"
              error={fieldState.invalid}
              fullWidth
            />
          )}
        />
      )}
    </>
  );
};

export default TimeRestrictionField;
